<app-item-panel
  [title]="title"
  (selectionChanged)="onPanelSelectionChange($event)"
  [items]="panelItems"
>
</app-item-panel>
